import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Select, Input, Button, Tabs, Badge } from "antd";
import { DatePicker } from "antd";
import { getDataDoc } from "../../database";
import {
  getDocs,
  collection,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../database/firebase";
import { formatDate } from "../../utils/index";
import { downloadFolderAsZip, updateDocDatabase } from "../../database";
import { Modal } from "antd";
import { Spin } from "antd";
import {
  TableRow,
  TableHeaderCell,
  TableHeader,
  TableCell,
  TableBody,
  Icon,
  Table,
} from "semantic-ui-react";
import Clase from "./Clase";
import { openErrorNotification } from "../../Components/Notifications/errorNotification";
const { TextArea } = Input;

function ChangeLog() {
  const [scutiriPending, setScutiriPending] = useState([]);
  const [scutiriProcessed, setScutiriProcessed] = useState([]);
  const [activeTab, setActiveTab] = useState("pending");
  const clase = useSelector((state) => state.clase);
  const [isModalVisible, setModalVisible] = useState();
  const [motiv, setMotiv] = useState("");
  const [cObject, setCObject] = useState({});
  const [loading, setLoading] = useState(false);
  const fetchPendingData = async () => {
    const q = query(
      collection(db, "no-verify-scutiri"),
      where("verified", "==", "waiting")
    );
    const querySnapshot = await getDocs(q);

    let array = [];
    querySnapshot.forEach((doc) => {
      array.push({
        ...doc.data(),
      });
    });
    setScutiriPending(array);
  };

  const fetchProcessedData = async () => {
    const q = query(
      collection(db, "no-verify-scutiri"),
      where("verified", "in", ["accepted", "denied"])
    );
    const querySnapshot = await getDocs(q);

    let array = [];
    querySnapshot.forEach((doc) => {
      array.push({
        ...doc.data(),
      });
    });
    setScutiriProcessed(array);
  };

  useEffect(() => {
    fetchPendingData();
    const q = query(
      collection(db, "no-verify-scutiri"),
      where("verified", "==", "waiting")
    );
    const unsub3 = onSnapshot(q, () => {
      fetchPendingData();
      if (activeTab === "processed") {
        fetchProcessedData();
      }
    });
    return unsub3;
  }, [activeTab]);

  const handleTabChange = (key) => {
    setActiveTab(key);
    if (key === "processed" && scutiriProcessed.length === 0) {
      fetchProcessedData();
    }
  };

  return (
    <>
      <Modal
        title="Motivul respingerii"
        open={isModalVisible}
        onOk={async () => {
          if (!motiv) {
            openErrorNotification("Scrie de ce respingi această scutire");
            return;
          }
          setLoading(true);
          let c = cObject;

          try {
            const scutiriElev = await getDataDoc("eleviDocumente", c.elevId);
            const docsElev = [
              ...(scutiriElev.docsElev || []).filter(
                (scutire) => scutire.id !== c.id_scutire
              ),
              {
                ...(scutiriElev.docsElev || []).find(
                  (scutire) => scutire.id === c.id_scutire
                ),
                verified: "denied",
                motiv,
              },
            ];

            // Execute both updates in parallel
            await Promise.all([
              updateDocDatabase("no-verify-scutiri", c.id_scutire, {
                verified: "denied",
              }),
              updateDocDatabase("eleviDocumente", c.elevId, {
                docsElev,
              }),
            ]);
          } catch (error) {
            console.error("Error denying scutire:", error);
          } finally {
            setMotiv("");
            setCObject({});
            setModalVisible(false);
            setLoading(false);
          }
        }}
        onCancel={() => {
          setModalVisible(false);
          setMotiv("");
          setCObject({});
        }}
      >
        <TextArea
          value={motiv}
          onChange={(e) => setMotiv(e.target.value)}
          placeholder="Introdu motivul respingerii..."
          rows={4}
        />
      </Modal>
      <br />
      <h2>Administrator scutiri</h2>
      <br />
      <h3>Acceptă scutiri sau respinge scutiri</h3>
      <br />
      <Tabs activeKey={activeTab} onChange={handleTabChange}>
        <Tabs.TabPane
          tab={
            <Badge count={scutiriPending.length} offset={[10, 0]}>
              Scutiri în așteptare
            </Badge>
          }
          key="pending"
        >
          {loading === true ? (
            <Spin spinning={loading} size="large" />
          ) : (
            <Table celled>
              <TableHeader>
                <TableRow>
                  <TableHeaderCell>Elev</TableHeaderCell>
                  <TableHeaderCell>Clasa</TableHeaderCell>
                  <TableHeaderCell>Tip scutire</TableHeaderCell>
                  <TableHeaderCell>Titlu</TableHeaderCell>
                  <TableHeaderCell>Date</TableHeaderCell>
                  <TableHeaderCell>Încarcată</TableHeaderCell>
                  <TableHeaderCell>Detalii</TableHeaderCell>
                  <TableHeaderCell>Descarcă fișier</TableHeaderCell>
                  <TableHeaderCell>Aceptă sau respinge</TableHeaderCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                {scutiriPending.length === 0 ? (
                  <TableRow>
                    <TableCell
                      colSpan="9"
                      textAlign="center"
                      style={{ padding: "40px", color: "#999" }}
                    >
                      Nu există scutiri în așteptare
                    </TableCell>
                  </TableRow>
                ) : (
                  scutiriPending
                    ?.sort((a, b) => b.uploaded - a.uploaded)
                    ?.map((c) => {
                      return (
                        <TableRow warning={c.verified === "waiting"}>
                          <TableCell>{c.numeElev}</TableCell>
                          <TableCell>
                            {" "}
                            {clase?.find((cls) => cls.id === c.classId)
                              ?.anClasa +
                              clase?.find((cls) => cls.id === c.classId)
                                ?.identificator}
                          </TableCell>
                          <TableCell>
                            <p
                              style={{
                                width: "50%",
                                fontSize: "16px",
                                color: "black",
                              }}
                            >
                              {c.subType === "alte_motivari"
                                ? "Alte Motivări"
                                : c.subType === "profesor"
                                ? "Motivare Concurs"
                                : c.tip === "scutire"
                                ? "Scutire medicală"
                                : "Motivare părinte"}
                              <br />
                              <p style={{ fontSize: "12px" }}>
                                {c.tip === "scutire"
                                  ? "Nu scade din cele 40 de abs."
                                  : "Scade din cele 40 de abs."}
                              </p>
                            </p>
                          </TableCell>
                          <TableCell>{c.nume}</TableCell>
                          <TableCell>
                            {c?.ranges?.map((range) => (
                              <div>
                                {formatDate(new Date(range.start)) +
                                  " - " +
                                  formatDate(new Date(range.end))}
                                <br />
                                <br />
                              </div>
                            ))}
                          </TableCell>
                          <TableCell>
                            {formatDate(new Date(c.uploaded))}
                          </TableCell>
                          <TableCell>
                            <TextArea
                              value={c.details}
                              style={{ width: "100%", outline: "none" }}
                            />
                          </TableCell>
                          <Table.Cell>
                            <Button
                              type="primary"
                              onClick={() => {
                                downloadFolderAsZip(
                                  "documente" + c.id_scutire + "_" + c.uploaded,
                                  c.nume + "_document" + c.id
                                );
                              }}
                            >
                              Descarca Documente
                            </Button>
                          </Table.Cell>
                          <Table.Cell>
                            <Select
                              style={{ width: "100%" }}
                              onChange={async (e) => {
                                setLoading(true);
                                if (e === "denied") {
                                  setCObject(c);
                                  setModalVisible(true);
                                  setLoading(false);
                                  return;
                                }

                                try {
                                  // Run all operations in parallel
                                  const [scutiriElev, dataElev] =
                                    await Promise.all([
                                      getDataDoc("eleviDocumente", c.elevId),
                                      getDataDoc("users", c.elevId),
                                    ]);

                                  const docsElev = [
                                    ...(scutiriElev.docsElev || []).filter(
                                      (scutire) => scutire.id !== c.id_scutire
                                    ),
                                    {
                                      ...(scutiriElev.docsElev || []).find(
                                        (scutire) => scutire.id === c.id_scutire
                                      ),
                                      verified: e,
                                      motiv: "",
                                    },
                                  ];

                                  // Prepare all update operations
                                  const updatePromises = [
                                    updateDocDatabase(
                                      "no-verify-scutiri",
                                      c.id_scutire,
                                      {
                                        verified: e,
                                      }
                                    ),
                                    updateDocDatabase(
                                      "eleviDocumente",
                                      c.elevId,
                                      {
                                        docsElev,
                                      }
                                    ),
                                  ];

                                  // Add email notification if accepted
                                  if (e === "accepted") {
                                    updatePromises.push(
                                      updateDocDatabase(
                                        "mail",
                                        "docs" + Date.now(),
                                        {
                                          to: [
                                            dataElev.adresaEmail,
                                            ...(dataElev.parintii || []),
                                          ],
                                          message: {
                                            subject:
                                              "Elevului " +
                                              dataElev.numeDeFamilie +
                                              " " +
                                              dataElev.prenume +
                                              " i-a fost adaugată o nouă scutire",
                                            text: `Scutirea acopera datele: ${c.ranges?.map(
                                              (range) =>
                                                formatDate(
                                                  new Date(range.start)
                                                ) +
                                                " - " +
                                                formatDate(
                                                  new Date(range.end)
                                                ) +
                                                "; "
                                            )}.`,
                                          },
                                        }
                                      )
                                    );
                                  }

                                  // Execute all updates in parallel
                                  await Promise.all(updatePromises);
                                } catch (error) {
                                  console.error(
                                    "Error updating scutire:",
                                    error
                                  );
                                } finally {
                                  setLoading(false);
                                }
                              }}
                              value={c.verified}
                            >
                              <Select.Option value="waiting">
                                În așteptare
                              </Select.Option>
                              <Select.Option value="accepted">
                                Acceptat
                              </Select.Option>
                              <Select.Option value="denied">
                                Respins
                              </Select.Option>
                            </Select>
                          </Table.Cell>
                        </TableRow>
                      );
                    })
                )}
              </TableBody>
            </Table>
          )}
        </Tabs.TabPane>
        <Tabs.TabPane tab="Scutiri marcate" key="processed">
          {loading === true ? (
            <Spin spinning={loading} size="large" />
          ) : (
            <Table celled>
              <TableHeader>
                <TableRow>
                  <TableHeaderCell>Elev</TableHeaderCell>
                  <TableHeaderCell>Clasa</TableHeaderCell>
                  <TableHeaderCell>Tip scutire</TableHeaderCell>
                  <TableHeaderCell>Titlu</TableHeaderCell>
                  <TableHeaderCell>Date</TableHeaderCell>
                  <TableHeaderCell>Încarcată</TableHeaderCell>
                  <TableHeaderCell>Detalii</TableHeaderCell>
                  <TableHeaderCell>Descarcă fișier</TableHeaderCell>
                  <TableHeaderCell>Status</TableHeaderCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                {scutiriProcessed.length === 0 ? (
                  <TableRow>
                    <TableCell
                      colSpan="9"
                      textAlign="center"
                      style={{ padding: "40px", color: "#999" }}
                    >
                      Nu există scutiri procesate
                    </TableCell>
                  </TableRow>
                ) : (
                  scutiriProcessed
                    ?.sort((a, b) => {
                      const statusOrder = {
                        denied: 0,
                        accepted: 1,
                      };
                      if (statusOrder[a.verified] === statusOrder[b.verified]) {
                        return b.uploaded - a.uploaded;
                      }
                      return statusOrder[a.verified] - statusOrder[b.verified];
                    })
                    ?.map((c) => {
                      return (
                        <TableRow
                          positive={c.verified === "accepted"}
                          negative={c.verified === "denied"}
                        >
                          <TableCell>{c.numeElev}</TableCell>
                          <TableCell>
                            {" "}
                            {clase?.find((cls) => cls.id === c.classId)
                              ?.anClasa +
                              clase?.find((cls) => cls.id === c.classId)
                                ?.identificator}
                          </TableCell>
                          <TableCell>
                            <p
                              style={{
                                width: "50%",
                                fontSize: "16px",
                                color: "black",
                              }}
                            >
                              {c.subType === "alte_motivari"
                                ? "Alte Motivări"
                                : c.subType === "profesor"
                                ? "Motivare Concurs"
                                : c.tip === "scutire"
                                ? "Scutire medicală"
                                : "Motivare părinte"}
                              <br />
                              <p style={{ fontSize: "12px" }}>
                                {c.tip === "scutire"
                                  ? "Nu scade din cele 40 de abs."
                                  : "Scade din cele 40 de abs."}
                              </p>
                            </p>
                          </TableCell>
                          <TableCell>{c.nume}</TableCell>
                          <TableCell>
                            {c?.ranges?.map((range) => (
                              <div>
                                {formatDate(new Date(range.start)) +
                                  " - " +
                                  formatDate(new Date(range.end))}
                                <br />
                                <br />
                              </div>
                            ))}
                          </TableCell>
                          <TableCell>
                            {formatDate(new Date(c.uploaded))}
                          </TableCell>
                          <TableCell>
                            <TextArea
                              value={c.details}
                              style={{ width: "100%", outline: "none" }}
                              readOnly
                            />
                          </TableCell>
                          <Table.Cell>
                            <Button
                              type="primary"
                              onClick={() => {
                                downloadFolderAsZip(
                                  "documente" + c.id_scutire + "_" + c.uploaded,
                                  c.nume + "_document" + c.id
                                );
                              }}
                            >
                              Descarca Documente
                            </Button>
                          </Table.Cell>
                          <Table.Cell>
                            <span
                              style={{
                                color:
                                  c.verified === "accepted" ? "green" : "red",
                                fontWeight: "bold",
                              }}
                            >
                              {c.verified === "accepted"
                                ? "Acceptat"
                                : "Respins"}
                              {c.verified === "denied" && c.motiv && (
                                <div
                                  style={{
                                    fontSize: "12px",
                                    marginTop: "4px",
                                    color: "#666",
                                  }}
                                >
                                  Motiv: {c.motiv}
                                </div>
                              )}
                            </span>
                          </Table.Cell>
                        </TableRow>
                      );
                    })
                )}
              </TableBody>
            </Table>
          )}
        </Tabs.TabPane>
      </Tabs>
    </>
  );
}

export default ChangeLog;
